import { render, staticRenderFns } from "./TechnicalTextBlock.vue?vue&type=template&id=70c0a540&scoped=true&"
import script from "./TechnicalTextBlock.vue?vue&type=script&lang=js&"
export * from "./TechnicalTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTextBlock.vue?vue&type=style&index=0&id=70c0a540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c0a540",
  null
  
)

component.options.__file = "TechnicalTextBlock.vue"
export default component.exports